<template>
  <div class="display-elements">
    <div
      v-if="content.bottlesize && content.bottlesize.length > 0"
      class="display-element bottle-display"
    >
      <div class="item-element">
        <component
          class="icon"
          :is="sizeIcon"
        />
      </div>
      <div class="item-element">
        <div class="item-sub-element">
          <div class="label">
            {{ sizeLabel }}
          </div>
        </div>
        <div class="item-sub-element">
          <div class="value">
            {{ content.bottlesize }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="content.winebody && content.winebody.length > 0 && content.winebody !='unknown'"
      class="display-element bottle-display"
    >
      <div class="item-element">
        <component
          class="icon"
          :is="bodyIcon"
        />
      </div>
      <div class="item-element">
        <div class="item-sub-element">
          <div class="label">
            {{ bodyLabel }}
          </div>
        </div>
        <div class="item-sub-element">
          <div class="value">
            {{ content.winebody }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="content.wine_type && content.wine_type.length > 0"
      class="display-element wine-type"
    >
      <div class="item-element">
        <component
          class="icon"
          :is="typeIcon"
        />
      </div>
      <div class="item-element">
        <div class="item-sub-element">
          <div class="label">
            {{ typeLabel }}
          </div>
        </div>
        <div class="item-sub-element">
          <div class="value">
            {{ content.wine_type }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="content.varietal && content.varietal.length > 0"
      class="display-element wine-varietal"
    >
      <div class="item-element">
        <component
          class="icon"
          :is="varietalIcon"
        />
      </div>
      <div class="item-element">
        <div class="item-sub-element">
          <div class="label">
            {{ varietalLabel }}
          </div>
        </div>
        <div class="item-sub-element">
          <div class="value">
            {{ content.varietal.join(', ') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import IconComponents from './icons'

export default {
  name: 'key-info-display',
  components: IconComponents,
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    bodyIcon() { return this.getIconComponent(this.content.winebody_icon, 'wine-bottle-standard') },
    sizeIcon() { return this.getIconComponent(this.content.bottlesize_icon, 'wine-bottle-standard') },
    typeIcon() { return this.getIconComponent(this.content.wine_type_icon, 'wine-glass') },
    varietalIcon() { return this.getIconComponent(this.content.varietal_icon, 'varietal') },
    productLabels() { return this.$store.getters['products/getMap']('variable').product_labels ?? {} },
    sizeLabel() { return this.productLabels.size ?? 'Size' },
    typeLabel() { return this.productLabels.type ?? 'Type' },
    varietalLabel() { return this.productLabels.varietal ?? 'Varietal' },
    bodyLabel() { return this.productLabels.body ?? 'Body' }
  },
  methods: {
    getIconComponent(icon, fallback) {
      if (icon) return `${icon.slice(1).replace(/_/g, '-')}-icon`
      return `${fallback}-icon`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
.display-elements {
  --col-size: 2;

  grid-template-columns: repeat(var(--col-size), 1fr);
  display: grid;
  gap:1em;
  margin-bottom:1.5em;

  @include media-breakpoint-up(md) {
    --col-size:3;
  }

  .icon { width:3em; }

  .display-element {
    grid-column: span 1;
    display: flex;
    align-items: center;
    line-height:1;
  }

  .item-sub-element {
    &:not(:last-child){ margin-bottom:.5em; }
  }

  .label {
    font-weight:600;
  }

  .value {
    line-height: 1.25;
  }

  .item-element {
    &:not(:last-child){
      margin-right:.5em;
    }
  }
}
</style>
